import React from 'react';
import {Text} from 'react-native';
import styles from './FieldHeader.style';

export default function FieldHeader(props) {
  const {text, containerStyle} = props;
  return <Text style={[styles.text, containerStyle]}>{text}</Text>;
}
